const contentTagPattern = /<(audio|embed|hr|iframe|img|object|table|video)\b/i;
const invisibleCharacterPattern = /[\u200B-\u200D\uFEFF]/g;

export const isEmptyRichEditorValue = (value) => {
  if (value == null) {
    return true;
  }

  const html = String(value);

  if (contentTagPattern.test(html)) {
    return false;
  }

  const text = html
    .replace(/<br\s*\/?>/gi, "")
    .replace(/<\/?[^>]+>/g, "")
    .replace(/&ZeroWidthSpace;|&#8203;|&#x200B;/gi, "")
    .replace(/&nbsp;/gi, " ")
    .replace(invisibleCharacterPattern, "")
    .trim();

  return text === "";
};

export const normalizeRichEditorValue = (value) => {
  if (value == null) {
    return value;
  }

  if (isEmptyRichEditorValue(value)) {
    return "";
  }

  return value;
};

export const valueOrNullDefault = (value, defaultValue) => (
  value === null ? defaultValue : value
);
